"use strict";
export var ReactQueryCacheKey = /* @__PURE__ */ ((ReactQueryCacheKey2) => {
  ReactQueryCacheKey2["AbstractPoolPriceHistory"] = "AbstractPoolPriceHistory";
  ReactQueryCacheKey2["BscLpApproval"] = "BscLpApproval";
  ReactQueryCacheKey2["BscRemoveLiquidityApproval"] = "BscRemoveLiquidityApproval";
  ReactQueryCacheKey2["BscRemoveLiquidityCalldata"] = "BscRemoveLiquidityCalldata";
  ReactQueryCacheKey2["BscPoolPriceHistory"] = "BscPoolPriceHistory";
  ReactQueryCacheKey2["BscPoolVolumeHistory"] = "BscPoolVolumeHistory";
  ReactQueryCacheKey2["BscTokenPriceHistory"] = "BscTokenPriceHistory";
  ReactQueryCacheKey2["CameraPermission"] = "CameraPermission";
  ReactQueryCacheKey2["DensityChartData"] = "DensityChartData";
  ReactQueryCacheKey2["LocalActivities"] = "localActivities";
  ReactQueryCacheKey2["OnchainBalances"] = "OnchainBalances";
  ReactQueryCacheKey2["OnchainENS"] = "OnchainENS";
  ReactQueryCacheKey2["PositionCurrencyInfo"] = "positionCurrencyInfo";
  ReactQueryCacheKey2["PositionTokenURI"] = "PositionTokenURI";
  ReactQueryCacheKey2["SignatureToActivity"] = "SignatureToActivity";
  ReactQueryCacheKey2["TradingApi"] = "TradingApi";
  ReactQueryCacheKey2["AbstractLpApproval"] = "AbstractLpApproval";
  ReactQueryCacheKey2["TransactionToActivity"] = "TransactionToActivity";
  ReactQueryCacheKey2["UniswapApi"] = "UniswapApi";
  ReactQueryCacheKey2["UnitagsApi"] = "UnitagsApi";
  ReactQueryCacheKey2["WalletCapabilities"] = "WalletCapabilities";
  ReactQueryCacheKey2["IsSmartContractAddress"] = "IsSmartContractAddress";
  return ReactQueryCacheKey2;
})(ReactQueryCacheKey || {});
